/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	to_number
} from "svelte/internal";
import { lifeSpeed } from "src/store.js"

function create_fragment(ctx) {
	var div, label, t_1, input, dispose;

	return {
		c() {
			div = element("div");
			label = element("label");
			label.textContent = "Speed";
			t_1 = space();
			input = element("input");
			attr(input, "type", "range");
			attr(input, "min", "0");
			attr(input, "max", "990");
			attr(div, "class", "form-item");

			dispose = [
				listen(input, "change", ctx.input_change_input_handler),
				listen(input, "input", ctx.input_change_input_handler),
				listen(input, "change", ctx.onSpeedChange)
			];
		},

		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(div, t_1);
			append(div, input);

			set_input_value(input, ctx.$lifeSpeed);
		},

		p(changed, ctx) {
			if (changed.$lifeSpeed) set_input_value(input, ctx.$lifeSpeed);
		},

		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(div);
			}

			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $lifeSpeed;

	component_subscribe($$self, lifeSpeed, $$value => { $lifeSpeed = $$value; $$invalidate('$lifeSpeed', $lifeSpeed); });

	const onSpeedChange = ({ target }) => {
    lifeSpeed.set(parseInt(target.value))
  }

	function input_change_input_handler() {
		lifeSpeed.set(to_number(this.value));
	}

	return {
		onSpeedChange,
		$lifeSpeed,
		input_change_input_handler
	};
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, []);
	}
}

export default Component;